import { useEffect, useState } from "react";
import { Fingerprint, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { passkeySupported, registerPasskey, forgetPasskeyId } from "@/lib/passkey";
import { tr as t } from "@/lib/i18n";

export default function BiometricCard({ loginId }) {
  const [ok, setOk] = useState(null);
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/passkeys").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { passkeySupported().then(setOk); load(); }, []);
  const enable = async () => {
    setBusy(true);
    try { await registerPasskey(loginId); toast.success(t("تم تفعيل الدخول بالبصمة على هذا الجهاز")); load(); } catch (e) { toast.error(e?.response ? errMsg(e) : t(e.message || "تعذّر التفعيل")); }
    setBusy(false);
  };
  const remove = async (id) => {
    try { await api.delete(`/passkeys/${id}`); if (list.length === 1) forgetPasskeyId(); toast.success(t("تم إلغاء البصمة")); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const dev = (d) => t(/iPhone|iPad/.test(d) ? "آيفون" : /Android/.test(d) ? "أندرويد" : "جهاز");
  return (
    <div className="card p-4 space-y-3" data-testid="biometric-card">
      <div className="flex items-center gap-3">
        <span className="w-12 h-12 rounded-2xl bg-brand text-white flex items-center justify-center shrink-0"><Fingerprint className="w-7 h-7" /></span>
        <div className="flex-1"><b className="block text-lg">{t("الدخول بالبصمة أو الوجه")}</b>
          <span className="text-sm text-slate-500">{list.length ? t("مفعّل على {n} جهاز", { n: list.length }) : t("ادخل بلمسة بدل كتابة كلمة المرور")}</span></div>
      </div>
      {ok === false && <p className="text-sm text-amber-700 bg-amber-50 rounded-xl p-3" data-testid="biometric-unsupported">{t("هذا الجهاز أو المتصفح لا يدعم الدخول بالبصمة.")}</p>}
      {ok && <button data-testid="enable-biometric-btn" onClick={enable} disabled={busy} className="btn btn-lg btn-blue w-full">
        {busy ? <Loader2 className="w-6 h-6 animate-spin" /> : <Fingerprint className="w-6 h-6" />}{t("تفعيل البصمة على هذا الجهاز")}</button>}
      {list.map((p) => (
        <div key={p.id} className="flex items-center justify-between text-sm bg-slate-50 rounded-xl p-2 px-3" data-testid={`passkey-${p.id}`}>
          <span className="truncate">{dev(p.device)} — {p.created_at?.slice(0, 10)}</span>
          <button data-testid={`passkey-delete-${p.id}`} onClick={() => remove(p.id)} className="text-red-600 p-2" aria-label={t("إلغاء")}><Trash2 className="w-5 h-5" /></button>
        </div>
      ))}
    </div>
  );
}
